// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartPageTemplateBreakpoint } from "@steiner/App/Components/Cart/CartPageTemplate";
import { cartPageContainerStyles } from "@steiner/Overrides/Widgets/Cart/CartPageContainer";
import { hideElementOnPrint, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

cartPageContainerStyles.contentsContainer = {
    css: hideElementOnPrint,
};

cartPageContainerStyles.nonStockedItemsContainer = {
    css: css`
        display: flex;
        gap: 16px 22px;

        ${xScreen("lte", cartPageTemplateBreakpoint)} {
            flex-direction: column;
        }

        ${hideElementOnPrint}
    `,
};

cartPageContainerStyles.nonStockedItemsWrapper = {
    css: css`
        flex: 1;
    `,
};

cartPageContainerStyles.quickOrderWrapper = {
    css: css`
        flex: 1;
    `,
};

cartPageContainerStyles.footerSection = {
    css: hideElementOnPrint,
};
